export const SOFTLINE_API_LAGERSTAND_ARTIKEL_SUCHE = "/v1/lagerplatz/artikelid-suche/{{id}}";
